import { SESSIONS_SERVICE } from "@/services/sessions.service.js";

const state = { getSessionsForUserOutput: {} };

const actions = {
    getSessionsForUser({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getSessionsForUserRequest');

        SESSIONS_SERVICE.getSessionsForUser(id)
            .then(
                output => {
                    commit('getSessionsForUserSuccess', output);
                },
                error => {
                    commit('getSessionsForUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getSessionsForUser
    getSessionsForUserRequest(state) {
    },
    getSessionsForUserSuccess(state, output) {
        state.getSessionsForUserOutput = output;
    },
    getSessionsForUserFailure(state) {
        state.getSessionsForUserOutput = false;
    },
};

export const sessions = {
    namespaced: true,
    state,
    actions,
    mutations
};